import { Destination } from 'shared/types/destination';
import { Validator } from 'shared/components/MultiStepForm/types';

const validator: Validator<Destination> = (destination) => {
  if (!destination) {
    return 'Select a destination to continue.';
  }
};

export default validator;
